import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "error"];
import React from "react";
import { Alert, Box, Label } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var StripeInput = function StripeInput(_ref) {
  var label = _ref.label,
      error = _ref.error,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Label, {
    fontWeight: "light",
    fontSize: "base",
    color: error ? "error" : "text"
  }, label), ___EmotionJSX(Box, _extends({
    p: 4,
    border: 1,
    borderRadius: "default",
    borderColor: error ? "error" : "ui.borderColor"
  }, otherProps)), error && ___EmotionJSX(Alert, {
    type: "small",
    variant: "error",
    color: "error"
  }, error));
};